export default "__VITE_ASSET__e6ee52ae__"